import { createTheme } from '@mui/material/styles';

export function createAppTheme(primary = '#013b70', secondary = '#26b2b8', warning = '#FFCC00') {
  return createTheme({
    palette: {
      primary: {
        main: primary,
        light: primary,
        contrastText: '#ffffff',
      },
      secondary: {
        main: secondary,
        contrastText: '#ffffff',
      },
      warning: {
        main: warning,
      },
      error: {
        main: '#dc3545',
      },
      success: {
        main: '#198754',
      },
      background: {
        default: '#f8fafc',
        paper: '#ffffff',
      },
      text: {
        primary: '#2d3748',
        secondary: '#718096',
      },
    },
    typography: {
      fontFamily: '"Montserrat", sans-serif',
      h1: { fontFamily: '"Raleway", sans-serif', fontWeight: 700 },
      h2: { fontFamily: '"Raleway", sans-serif', fontWeight: 700 },
      h3: { fontFamily: '"Raleway", sans-serif', fontWeight: 600 },
      button: { textTransform: 'none', fontWeight: 600 },
    },
    shape: {
      borderRadius: 8,
    },
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 10,
            fontFamily: '"Montserrat", sans-serif',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#e2e8f0',
              borderWidth: 2,
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: primary,
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: primary,
              borderWidth: 2,
            },
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            fontFamily: '"Montserrat", sans-serif',
            fontSize: '12px',
            fontWeight: 600,
            color: '#4a5568',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            '&.Mui-focused': {
              color: primary,
            },
          },
          shrink: {
            fontSize: '11px',
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 20,
            padding: '8px 20px',
            transition: 'all 0.2s ease',
            '&:hover': {
              transform: 'translateY(-1px)',
            },
          },
          containedPrimary: {
            background: `linear-gradient(135deg, ${primary} 0%, ${primary}cc 100%)`,
            boxShadow: 'none',
            '&:hover': {
              background: `linear-gradient(135deg, ${primary}dd 0%, ${primary} 100%)`,
              boxShadow: `0 4px 12px ${primary}4d`,
            },
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            boxShadow: `0 4px 16px ${primary}14`,
          },
        },
      },
      MuiDataGrid: {
        styleOverrides: {
          root: {
            border: 'none',
            fontFamily: '"Montserrat", sans-serif',
          },
          columnHeaders: {
            backgroundColor: primary,
            color: '#ffffff',
          },
          columnHeaderTitle: {
            fontWeight: 700,
            fontSize: '0.8rem',
            textTransform: 'uppercase',
            letterSpacing: '0.04em',
          },
          row: {
            '&:hover': {
              backgroundColor: `${primary}0a`,
            },
            '&:nth-of-type(even)': {
              backgroundColor: '#f8fafc',
            },
          },
          sortIcon: {
            color: warning,
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            fontWeight: 600,
            fontSize: '0.75rem',
          },
        },
      },
      MuiTextField: {
        defaultProps: {
          variant: 'outlined',
          size: 'small',
        },
      },
    },
  });
}

export default createAppTheme();
